import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const BroadcastList = () => import('./BroadcastList.vue');
const BroadcastForm = () => import('./BroadcastForm.vue');
const BroadcastShow = () => import('./BroadcastShow.vue');

const meta = {
  permissions: ['administrator'],
  featureFlag: FEATURE_FLAGS.BROADCASTS_VISIBILITY,
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/broadcasts'),
    name: 'broadcasts_index',
    component: BroadcastList,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/broadcasts/new'),
    name: 'broadcasts_new',
    component: BroadcastForm,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/broadcasts/:id'),
    name: 'broadcasts_show',
    component: BroadcastShow,
    props: true,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/broadcasts/:id/edit'),
    name: 'broadcasts_edit',
    component: BroadcastForm,
    props: true,
    meta,
  },
];
